// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900);"]);
// Module
exports.push([module.id, "#stepper,#stepper .v-stepper__header{box-shadow:none}#stepper .v-stepper__label{display:flex!important}", ""]);
// Exports
module.exports = exports;
